import { useTranslation } from 'react-i18next'

export function NotFoundPage(): React.ReactElement {
  const { t } = useTranslation()
  // Render
  return <div className="w-full h-full flex justify-center items-center">{t('not_found')}</div>
}
